export default "__VITE_ASSET__29285520__"